import React from 'react'
import "./Privacy_policy.css";
// import "../Terms_conditions/Terms_conditions.css";
import Common_Banner from '../common-components/common-banner/Common_Banner';
import { Container } from 'react-bootstrap';
import Accept_btn from '../common-components/common-btn/accept_btn/Accept_btn';
import Decline_btn from '../common-components/common-btn/decline_btn/Decline_btn';


const Privacy_policy = () => {
  const breadcrumbs = [
    { label: "Home", link: "/gallery", isActive: false },
    { label: "SPORTS PROGRAMS", link: "", isActive: true },
  ];
  return (
    <>

      <Common_Banner
        imgSrc={"/assets/images/footer/privacy_policy/policy.png"}
        title_text="Privacy & Policy"
        breadcrumbs={breadcrumbs}
      />
      <section className='privacy_policy terms-section'>
        <Container>
          <div className='card card_div'>
            <p className='intro'>
              Welcome to Ashva Sports & Fitness<br />
              We value your privacy and are committed to protecting your personal information.<br />
              This Privacy Policy explains how we collect, use, store, and safeguard your data
              when you visit our website, register for our programs, or use our services.
            </p>
            <h2 className='head_div'>1. INTRODUCTION</h2>
            <div className='description_div'>
              <p className='grey_class'>
                By accessing or using our website, programs, or services,
                you agree to comply with and be bound by these Terms and Conditions.<br />
                Please read them carefully before using our website or participating
                in any of our sports or fitness programs.
              </p>
            </div>
            <h2 className='head_div'>2. INFORMATION WE COLLECT</h2>
            <div className='description_div' >
              <p className='grey_class'>We collect information to provide better services and enhance your experience.<br />This may include:</p>
              <p className='grey_class'>Personal Information:<br />Name, age, contact number, email address, gender, and emergency contact details</p>
              <p className='grey_class'>Registration Information:<br /> Program preferences, membership details, and payment history. </p>
              <p className='grey_class'> Technical Data:<br />  IP address, browser type, device information, and pages visited on our website. </p>
              <p className='grey_class'>Media & Feedback: <br /> Photos, videos, or testimonials voluntarily shared during events or programs. </p>
            </div>

            <h2 className='head_div'>3. HOW WE USE YOUR INFORMATION</h2>
            <div className='description_div'>
              <p className='grey_class'>We use your data to:</p>
              <p className='grey_class'>Register you for sports and fitness programs. </p>
              <p className='grey_class'>Communicate program schedules, updates, and offers.</p>
              <p className='grey_class'> Process payments and send receipts.</p>
              <p className='grey_class'>  Improve website functionality and user experience. </p>
              <p className='grey_class'>  Share event highlights or achievements (only with consent). </p>
              <p className='grey_class'>  Maintain safety, compliance, and record-keeping purposes.</p>
            </div >
            <h2 className='head_div'>4. DATA PROTECTION & SECURITY</h2>
            <div className='description_div'>
              <p className='grey_class' >We take all reasonable steps to ensure your data is secure. </p>
              <p className='grey_class'>Your personal information is stored on secure servers with restricted access. </p>
              <p className='grey_class'> Sensitive data like payment details is processed through trusted, encrypted gateways.</p>
              <p className='grey_class'>Only authorized personnel have access to user records.</p>
              <p className='grey_class'>However, no online system is 100% secure, and we cannot guarantee absolute protection.</p>
            </div>
            <h2 className='head_div'>5. SHARING OF INFORMATION</h2>
            <div className='description_div'>
              <p className='grey_class'>We respect your privacy — we do not sell or rent your personal data.<br /> We may share limited information only when:</p>
              <p className='grey_class'> Required by law or government authorities. </p>
              <p className='grey_class'>Necessary for program administration or event coordination (e.g., tournament registration lists). </p>
              <p className='grey_class'>With trusted partners (e.g., payment gateways or trainers) to facilitate services — under strict confidentiality agreements.</p>
            </div>

            <h2 className='head_div'>6. COOKIES & TRACKING</h2>
            <div className='description_div'>
              <p className='grey_class'>Our website uses cookies to improve user experience and analyze traffic.<br />
                Cookies help us remember your preferences and deliver relevant content.<br />
                You can choose to disable cookies through your browser settings, though some
                website features may not function fully.
              </p>
            </div>

            <h2 className='head_div'>7. PHOTOS & MEDIA USE</h2>
            <div className='description_div'>
              <p className='grey_class' >By participating in our programs or events, you consent
                to the use of photos or videos taken during sessions for promotional purposes —
                unless you explicitly request otherwise in writing.</p>
            </div>

            <h2 className='head_div'>8. YOUR RIGHTS</h2>
            <div className='description_div'>
              <p className='grey_class' >You have the right to: </p>
              <p className='grey_class' > Access, update, or correct your personal information. </p>
              <p className='grey_class' >Request deletion of your data (subject to verification).  </p>
              <p className='grey_class' >Withdraw consent for promotional communication at any time. </p>
              <p className='grey_class' >To exercise these rights, contact us using the details below.</p>
            </div>

            <h2 className='head_div'>9. THIRD-PARTY LINKS</h2>
            <div className='description_div'>
              <p className='grey_class' >Our website may contain links to other websites or social media pages.<br />
                We are not responsible for their privacy practices or content. <br />
                We encourage you to review their privacy policies when visiting those sites.
              </p>

            </div>

            <h2 className='head_div'>10.UPDATES TO THIS POLICY</h2>
            <div className='description_div'>
              <p className='grey_class'>We may update this Privacy Policy periodically to reflect new regulations or business changes.<br />
                Updates will be posted on this page, and the revised date will indicate the latest version.
              </p>
            </div>

            <h2 className='head_div'>11. CONTACT US</h2>
            <div className='description_div'>
              <p className='grey_class'>
                If you have any questions or concerns regarding these Terms, please contact us:<br />
                📧 Email: [info@yourwebsite.com]<br />
                📞 Phone: +91 [Your Number] <br />
                📍 Address: [Your Sports Center / Office Location]</p>
            </div>

            {/* Buttons container */}
            {/* <div className="btn_class d-flex justify-content-center gap-2 ">
              <Decline_btn />
              <Accept_btn />
            </div> */}
          </div>
        </Container>

      </section >
    </>
  )
}

export default Privacy_policy